import gsap from 'gsap'

export const initParallax = () => {
	const elementsToParallax = document.querySelectorAll('[data-parallax="1"]')

	if (!elementsToParallax.length) return
	
	elementsToParallax.forEach(element => {
		gsap.fromTo(element, {
			y: '-15%',
			scale: 1.15,
		}, {
			y: '15%',
			scale: 1.15,
			ease: 'none',
			scrollTrigger: {
				trigger: element,
				start: 'top bottom',
				end: 'bottom top',
				scrub: true
			}
		})
	})
}

export default () => {} 